import './playback-page-template.less';
import PlaybackPageTemplate from './playback-page-template';

export default PlaybackPageTemplate;
